export default {
	label: {
		project: 'Accueil',
		projects: 'Projets',
		users: 'Utilisateurs',
		exportsPaymentList: 'Export',
		exports: 'Exports',
		exportsAccessMaster: 'Exports',
		fileStorageAdministration: 'Drive',
		fileStorage: 'Contrôle',
		projectImport: 'Import',
		genericImportContact: 'Import Contact',
		projectGroup: 'Indicateurs',
		patientAdd: 'Ajout de patients',
		addressingAdd: 'Import PCR',
		payments: 'Paiements A51',
		paymentsPCR: 'Paiements G51',
		paymentsDGOS: 'Paiements DGOS',
		paymentAdd: 'Ajout de paiements',
		genericImportActor: 'Import des destinataires',
		billingPatients: 'Facturation',
		surveyCampaign: 'Expérience patient',
		surveyCampaignReportByProject: 'Suivi par structure',
		undues: 'Indus'
	},
	subLabel: {
		administration: 'Administration',
		validation: 'Validation',
		validation_dgos: 'Validation DGOS',
		liquidation: 'Liquidation',
		supervision: 'Supervision',
		projectImport: 'Import',
		evaluation_dm: 'evaluation_dm',
		evaluation_tc: 'evaluation_tc',
		control_file_dm: 'Fichier de contrôle DM',
		control_file_tc: 'Fichier de contrôle TC',
		exp_patient_administration: 'Complétion questionnaires',
		dgos: 'dgos',
		projectGroupActive: 'Groupements actifs',
		projectGroupInactive: 'Groupements inactifs',
		surveyCampaignAnalytics: 'Analyse de campagne',
		undue_list: 'Liste des indus',
		undue_add: 'Déclarer un indu',
		control_file: 'Fichiers de contrôle',
		undue_import: 'Import indus'
	}
};
